<template>
  <nav aria-label="Page navigation">
    <ul class="pagination">
      <li
        :class="['page-item', { disabled: currentPage === 1 }]"
        @click.prevent="goToFirstPage"
      >
        <a href="#" class="page-link">« First</a>
      </li>

      <li
        :class="['page-item', { disabled: currentPage === 1 }]"
        @click.prevent="previousPage"
      >
        <a href="#" class="page-link">‹ Prev</a>
      </li>

      <li
        v-for="page in displayedPages"
        :key="page"
        :class="['page-item', { active: page === currentPage }]"
        @click.prevent="goToPage(page)"
      >
        <a href="#" class="page-link">{{ page }}</a>
      </li>

      <li
        :class="['page-item', { disabled: currentPage === totalPages }]"
        @click.prevent="nextPage"
      >
        <a href="#" class="page-link">Next ›</a>
      </li>

      <li
        :class="['page-item', { disabled: currentPage === totalPages }]"
        @click.prevent="goToLastPage"
      >
        <a href="#" class="page-link">Last »</a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    currentPage: { type: Number, required: true },
    totalPages: { type: Number, required: true }
  },
  computed: {
    displayedPages() {
      const maxVisiblePages = 5;
      const half = Math.floor(maxVisiblePages / 2);
      let start = Math.max(1, this.currentPage - half);
      let end = Math.min(this.totalPages, start + maxVisiblePages - 1);

      if (end - start + 1 < maxVisiblePages) {
        start = Math.max(1, end - maxVisiblePages + 1);
      }

      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    }
  },
  methods: {
    previousPage() {
      if (this.currentPage > 1) this.$emit("page-change", this.currentPage - 1);
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.$emit("page-change", this.currentPage + 1);
    },
    goToFirstPage() {
      if (this.currentPage > 1) this.$emit("page-change", 1);
    },
    goToLastPage() {
      if (this.currentPage < this.totalPages) this.$emit("page-change", this.totalPages);
    },
    goToPage(page) {
      this.$emit("page-change", page);
    }
  }
};
</script>

<style scoped>
.pagination {
  display: flex;
  list-style: none;
  padding-left: 0;
  gap: 0px;
  justify-content: center;
  margin: 15px 0;
}

.page-item {
  cursor: pointer;
}

.page-item.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.page-item.active .page-link {
  background-color: #007bff;
  color: #fff;
  border-color: #007bff;
  box-shadow: 0 2px 6px rgba(0, 123, 255, 0.3);
  font-weight: 600;
  z-index: 0;
}

.page-link {
  position: relative;
  display: block;
  padding: 6px 12px;
  font-size: 12px;
  color: #007bff;
  background-color: #fff;
  border: 1px solid #dcdcdc;
  transition: all 0.2s ease-in-out;
}

.page-link:hover {
  background-color: #f1f7ff;
  border-color: #b4d2ff;
  color: #0056b3;
}

.page-link:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
}
</style>